/* Orizza — PDP "Spotted on them" reels (sections/orizza-pdp-reels.liquid).
   Clicking a tile opens the full-screen player: the reel's video (kept in a
   <template> so it only loads when opened) over its cover image, with the
   product name/price linking to the product. Closes on the Close button,
   a click outside the video, or Escape. Rail arrows/dots come from
   orizza-pdp-discover.js. */
(function () {
  function initReels(root) {
    if (root.dataset.ozReelsInit) return;
    root.dataset.ozReelsInit = 'true';

    var modal = root.querySelector('[data-oz-reel-modal]');
    if (!modal) return;
    var frame = modal.querySelector('[data-oz-reel-frame]');
    var meta = modal.querySelector('[data-oz-reel-meta]');
    var nameEl = modal.querySelector('[data-oz-reel-name]');
    var priceEl = modal.querySelector('[data-oz-reel-price]');
    var closeBtn = modal.querySelector('[data-oz-reel-close]');
    var lastFocus = null;

    function clearVideo() {
      var video = frame.querySelector('video');
      if (video) {
        video.pause();
        video.remove();
      }
    }

    function open(tile) {
      lastFocus = document.activeElement;
      clearVideo();

      var poster = tile.dataset.poster;
      frame.style.backgroundImage = poster ? 'url(' + poster + ')' : '';

      var tpl = tile.querySelector('template[data-oz-reel-video]');
      if (tpl) {
        var clone = tpl.content.cloneNode(true);
        var video = clone.querySelector('video');
        frame.insertBefore(clone, frame.firstChild);
        if (video) {
          var played = video.play();
          // browsers may refuse sound without a gesture they trust; retry muted
          if (played && played.catch) played.catch(function () { video.muted = true; video.play().catch(function () {}); });
        }
      }

      nameEl.textContent = tile.dataset.name || '';
      priceEl.textContent = tile.dataset.price || '';
      meta.hidden = !tile.dataset.name;
      if (tile.dataset.link) meta.setAttribute('href', tile.dataset.link);
      else meta.removeAttribute('href');

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      clearVideo();
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    root.querySelectorAll('[data-oz-reel]').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        // the product strip is a link to the product, not a play button
        if (e.target.closest('[data-oz-reel-product][href]')) return;
        open(tile);
      });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(tile);
        }
      });
    });

    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-oz-reels]').forEach(initReels);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
